import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./UserPlanNav.css";
import {BackArrowIcon2, New_ScrollX2025} from "../../assets/icons";
import Setting from "../Setting/Setting";

const UserPlanNav = () => {
  const navigate = useNavigate();

  const location = useLocation();
  // console.log('UserPlanNav location = ',location);

  const { isDashboard, projectId, isCard , pathSegment, isMoreInfo} = location.state || {};
  const pathSegments = location.pathname.split("/");
  //  console.log('pathSegments = ',pathSegments, pathSegments.length);
  const pathname = pathSegments[1];
  // console.log('More Info Setting Profile pathname=> ',pathname);

  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  const navigateHandler = () =>{

    if (isDashboard && isMoreInfo){
      navigate("/more_info", { state: { isDashboard: true, isMoreInfo:false} });   // MoreInfo To Dashboard
    }else if (isDashboard && !isMoreInfo) {
      navigate(`/dashboard`);
    } else if (!isDashboard && isMoreInfo && isCard ) { // Card Project Navbar => MoreInfo => User-Plan => Plan-Details
      navigate("/more_info", { state: { isDashboard: false, isMoreInfo:false, isCard:isCard, projectId:projectId } });   
    }else if (!isDashboard && isMoreInfo && !isCard){  // Scroll Project Navbar => MoreInfo => User-Plan => Plan-Details
      navigate("/more_info", { state: { isDashboard: false, isMoreInfo:false, isCard:isCard, projectId:projectId } }); 
    }else if (!isDashboard && !isMoreInfo && isCard){
      navigate(`/dashboard/card/${projectId}`, { state: { isDashboard: false, isMoreInfo:false, isCard:isCard, projectId:projectId } });
    }else if (!isDashboard && !isMoreInfo && !isCard){
      navigate(`/dashboard/scroll/${projectId}`, { state: { isDashboard: false, isMoreInfo:false, isCard:isCard, projectId:projectId } });
    }
  
  }

  //  Get Profile Icon Letter
  const getUserInitials = () => {
    const firstName = userInfo?.firstName?.trim() || "";
    // const lastName = userInfo?.lastName?.trim() || "";
    if (firstName) {
      return `${firstName.charAt(0).toUpperCase()}`;
    }
    return "U"; // Default initial if no name is available
  };

  const getBackgroundColor = () => {
    const initials = getUserInitials(); // Get initials
    const firstLetter = initials.charAt(0); // Extract first letter

    // console.log("First Letter for Color:", firstLetter); // Debugging

    const colors = {
      A: "#413CAA",
      B: "#413CAA",
      C: "#413CAA",
      D: "#413CAA",
      E: "#413CAA",
      F: "#413CAA",
      G: "#413CAA",
      H: "#413CAA",
      I: "#413CAA",
      J: "#413CAA",
      K: "#413CAA",
      L: "#413CAA",
      M: "#413CAA",
      N: "#413CAA",
      O: "#413CAA",
      P: "#413CAA",
      Q: "#413CAA",
      R: "#413CAA",
      S: "#413CAA",
      T: "#413CAA",
      U: "#413CAA",
      V: "#413CAA",
      W: "#413CAA",
      X: "#413CAA",
      Y: "#413CAA",
      Z: "#413CAA",
    };

    return colors[firstLetter] || "#413CAA"; // Default color if not found
  };

  return (
    <>
      <nav className="w-full h-full render_navbar flex flex-wrap items-center justify-between text-slate-200 focus:text-sly-700 drop-shadow-2xl ">
        <div className="w-full h-full flex flex-wrap items-center justify-between px-[16px]">
          <div className="flex items-center w-[15%]">
            <button className="flex items-center" onClick={navigateHandler}>
              <img className=" w-[11px] cursor-pointer" src={BackArrowIcon2} alt=""/>
            </button>

            <div className="flex items-center pl-[7%]">
              <img className="w-[35px] " src={New_ScrollX2025} />
              <span className="ml-[10px] Syne700 text-xl  tracking-wide ">ScrollX.io</span>
            </div>
          </div>

          <div className="w-[55%] flex justify-center items-center">
            <h1 className="manrope-600 text-[15px] text-white ">{pathname==='more_info' ? "Billing Info" : "Choose Plan"}</h1>             
          </div>

          <div className="flex justify-end w-[15%]">
            <button className="w-[35px] h-[35px] rounded-full" onClick={() => setIsSettingOpen(true)} style={{ backgroundColor: getBackgroundColor() }}>
              <div className="flex justify-center items-center text-white text-xl manrope-600 w-[35px] h-[35px] rounded-full ">
                <span className="manrope-600 text-white text-xl text-center ">{getUserInitials()}</span>
              </div>
            </button>
          </div>
        </div>
      </nav>
      <Setting isSettingOpen={isSettingOpen} setIsSettingOpen={setIsSettingOpen}/>
    </>
  );
};

export default UserPlanNav; 